<template>
  <div class="container">
<!--     <div class="image-ribbon"></div> -->
    <div class="backIndex" @click="$router.push('/aviation/index')">
      <div>答题首页</div>
    </div>
    <div class="image-pic1"></div>
    <div class="image-pic2"></div>
    <!-- <div class="image-pic3"></div> -->
    <img class="image-title" src="../../../assets/images/lottery_title.png">
    <div class="tips-text">
      您还剩余 {{ drawnum }} 次抽奖机会<span @click="$router.push(`winningrecord?id=${$route.query.id}`)" class="nav-link">查看中奖记录</span>
    </div>
    <div class="lottery-wrapper">
      <lottery
        @lotteryClick="lotteryClick"
        @lotteryDone="lotteryDone"
        :lottery-start="lotteryStart"
        :lottery-prizenum="6"
        :lottery-prizeno="prizeno"
        :lottery-bg="turnplate"
        :content-bg="turntable"
        :pointer-bg="pointer"
      />
    </div>
    <div class="bottom-button">
      <p>欢迎参加广东省航空绘画大赛，具体通知见广东省航空学会微信公众号，在对话框中回复航空科普绘画大赛，即可报名参与。</p>
      <!-- <van-button block size="large" type="primary" @click="hrefTo">前往参赛</van-button> -->
    </div>
    <van-popup class="qrcode" v-model="showQR">
      <p>亲，长按识别二维码</p>
      <p>关注“广东科技报”公众号</p>
      <p>即可参与抽奖！</p>
      <img src="../../../assets/images/qrcode.jpg" alt="">
      <van-button @click="showQR = false">返回</van-button>
    </van-popup>
  </div>
</template>

<script>

  import turnplate from '../../../assets/images/turnplate-bg.png'
  import turntable from '../../../assets/images/turntable.png'
  import pointer from '../../../assets/images/pointer.png'
  import API from '../../../interface/api'
  import wx from 'weixin-js-sdk'
  const u = navigator.userAgent
  export default {
    name: 'aviationlucklottery',
    data () {
      return {
        turnplate,
        turntable,
        pointer,
        showQR: false,
        drawnum: 0,
        daydtcs: 0,
        prizeno: 0,
        orgPrizeno: 0,
        drawing: false,
        lotteryStart: 0,
        issubscribe: false
      }
    },
    created () {
      this.$fetch.get(API.AVIATIONGETMEMBERDRAWNUM, {
        examid: this.$route.query.id
      }).then(response => {
        // console.log(response)
        if (response.status !== 200) {
          var message = response.message ? response.message : '抽奖次数获取失败，请刷新！'
          this.$toast.fail(message)
          return
        }
        this.issubscribe = response.data.issubscribe
        this.drawnum = response.data.drawnum
        this.daydtcs = response.data.daydtcs
      }).catch(error => {
        console.log(error)
      })
      var _this = this
      if (u.indexOf('MicroMessenger') > -1) {
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
        var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        let url=''
        if (isAndroid) {
          url=location.href
        }
        if (isIOS) {
          url=location.href.split('#')[0]  //hash后面的部分如果带上ios中config会不对
        }
        this.$fetch.get(API.GETWECHATINVOKESIGN, {
          url: url
        }).then(res => {
          let data = res.data
          wx.config({
            debug: false,
            appId: data.appId, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.nonceStr, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名，见附录1
            jsApiList: ['onMenuShareTimeline', 'updateAppMessageShareData', 'onMenuShareWeibo', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          })
          wx.ready(function(){
            wx.onMenuShareTimeline({
              title: '航空科普知识挑战赛等你来参加', // 分享标题
              link: window.location.origin + window.location.pathname + '#/aviation/index', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: 'https://ms.gdkjb.com/resources/images/logo/aviation_share_logo.png', // 分享图标
              success: function () {
                setTimeout(function(){
                  _this.share()
                }, 600)
              }
            })
            wx.updateAppMessageShareData({
              title: '航空科普知识挑战赛等你来参加',
              desc: '让你了解更多的航空科普知识，激发探究航空航天的兴趣。',
              link: window.location.origin + window.location.pathname + '#/aviation/index',
              imgUrl: 'https://ms.gdkjb.com/resources/images/logo/aviation_share_logo.png',
              success: function() {
                console.log('分享成功')
              }
            })
            // wx.updateTimelineShareData({
            //   title: '航空科普知识挑战赛等你来参加',
            //   link: window.location.origin + window.location.pathname + '#/aviation/index',
            //   imgUrl: 'https://ms.gdkjb.com/resources/images/logo/aviation_share_logo.png',
            //   success: function() {
            //     console.log('分享成功')
            //   }
            // })
            wx.onMenuShareWeibo({
              title: '航空科普知识挑战赛等你来参加',
              desc: '让你了解更多的航空科普知识，激发探究航空航天的兴趣。',
              link: window.location.origin + window.location.pathname + '#/aviation/index',
              imgUrl: 'https://ms.gdkjb.com/resources/images/logo/aviation_share_logo.png',
              success: function() {
                console.log('分享成功')
              },
              cancel: function(){
                console.log('分享取消')
              }
            })
          })
        })
      }
    },
    methods: {
      lotteryClick() {
        // this.prizeno = 3
        // this.lotteryStart = 1
        // return

        if (!this.issubscribe) {
          this.showQR = true
          return
        }

        if (this.drawing) return
        if (this.drawnum < 1) {
          this.$toast('您目前没有可抽奖次数')
          return
        }
        if (this.daydtcs < 1) {
          this.$toast('亲，要先答题才能抽奖拿奖品哟～～')
          return
        }
        this.$fetch.get(API.AVIATIONMEMBERDRAW, {
          examid: this.$route.query.id
        }).then(response => {
          if (response.status !== 200) {
            var message = response.message ? response.message : '抽奖次数获取失败，请刷新！'
            this.$toast.fail(message)
            return
          }
          // 1,2,3,4,5,6,7,8：门票(6),2：红包(1、3、5)
          // 编号99即谢谢(2/4)
          // let prizeArr = [0,6,6,6,6,6,6,6,6,3]
          // console.log(response.data.prize_no,prizeArr[response.data.prize_no])
          this.orgPrizeno = response.data.prize_no
          if ([1,2,3,4,5,6,7,8].includes(response.data.prize_no)) {
            this.prizeno = 6
          } else if ([9].includes(response.data.prize_no)) {
            let hongbaoArr = [1,3,5]
            var hongbaoNum = Math.floor(Math.random() * (3 - 1 + 1))
            this.prizeno = hongbaoArr[hongbaoNum] || 1
          } else {
            let xiexieArr = [2,4]
            var xiexieNum = Math.floor(Math.random() * (2 - 1 + 1))
            this.prizeno = xiexieArr[xiexieNum] || 2
          }
          // this.prizeno = prizeArr[response.data.prize_no] || 2
          this.lotteryStart = 1
          this.drawing = true
          this.drawnum = this.drawnum - 1
        }).catch(error => {
          console.log(error)
        })
      },
      lotteryDone() {
        let message = ''
        if ([1,2,3,4,5,6,7,8].includes(this.orgPrizeno)) {
          let ticket = {
            1: '西樵山国家风景门票',
            2: '广东天井山国家森林公园门票',
            3: '丹霞山门票',
            4: '广东三岭山国家森林公园门票',
            5: '饶平青岚国家地质公园门票',
            6: '肇庆星湖国家级风景名胜区门票',
            7: '广东流溪河国家森林公园门票',
            8: '广东流溪河国家森林公园五指山景区门票'
          }
          this.$dialog.alert({
            title: `恭喜您抽中`,
            message: `${ticket[this.orgPrizeno]}门票！`
            // message
          }).then(() => {
          })
        } else if ([9].includes(this.orgPrizeno)) {
          this.$dialog.alert({
            title: '恭喜您抽中0.5元红包！'
            // message
          }).then(() => {
          })
        } else {
          this.$dialog.alert({
            title: '谢谢参与'
            // message
          }).then(() => {
          })
        }
        this.lotteryStart = 0
        this.drawing = false
      },
      share () {
        this.$fetch.get(API.AVIATIONINDEXSHARE, {
          examid: this.$route.query.id
        }).then(shareRes => {
          // console.log('分享成功')
          if (shareRes.status === 200) {
            this.$fetch.get(API.AVIATIONGETMEMBERDRAWNUM, {
              examid: this.$route.query.id
            }).then(drawres => {
              // console.log(response)
              if (drawres.status !== 200) {
                var message = drawres.message ? drawres.message : '抽奖次数获取失败，请刷新！'
                this.$toast.fail(message)
                return
              }
              this.issubscribe = drawres.data.issubscribe
              this.drawnum = drawres.data.drawnum
              this.daydtcs = drawres.data.daydtcs
            }).catch(drawerr => {
              console.log(drawerr)
            })
          }
        }).catch(shareErr => {
          console.log(shareErr)
        })
      },
      hrefTo() {
        location.href = 'https://www.gdkjb.com/special/dasaiindex.html'
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .container
    background-color #F25151
    background-image url('../../../assets/images/ribbon@2x.png')
    background-repeat no-repeat
    background-position 98px 48vh
    background-size 323px 404px
  // .image-ribbon
  //   position absolute
  //   top 48vh
  //   right 0px
  //   width 323px
  //   height 404px
  //   background url('../../../assets/images/ribbon@2x.png') no-repeat
  //   background-size 323px 404px
  .image-pic1
    position absolute
    left 2px
    top 40%
    width 28px
    height 55px
    transform translateY(-50%)
    background url('../../../assets/images/lottery_pic1@2x.png') no-repeat
    background-size 28px 55px
  .image-pic2
    position absolute
    right 8px
    bottom 25%
    width 32px
    height 41px
    background url('../../../assets/images/lottery_pic2@2x.png') no-repeat
    background-size 32px 41px
    z-index 1
  .image-pic3
    position absolute
    left 10%
    bottom 5%
    width 38px
    height 48px
    background url('../../../assets/images/lottery_pic3@2x.png') no-repeat
    background-size 38px 48px
    z-index 1
  .image-title
    display block
    width 66.5%
    height auto
    margin 5px auto 10px
  .tips-text
    font-size 17px
    color #ffffff
  .lottery-wrapper
    width 85%
    margin 20px auto 15px
  .nav-link
    padding 10px
    color #ffe977
    cursor pointer
    margin-left 10px
    text-decoration underline
    &:active
      color #fba301
  .bottom-button
    margin 0 20px 40px
    padding 20px 14px
    background-color rgba(245,151,1,0.8)
    border-radius 8px
    p
      color #FFF
      font-size 16px
      line-height 22px
      text-align left
      text-indent 2em
      // margin-bottom 16px
    .van-button--primary
      background-color #D00202
      border-radius 8px
      border none
      font-size 16px
      height 40px
      line-height 40px
      width 195px
      margin auto
      &:active
        filter brightness(0.95)
  .qrcode
    width 80%
    padding 20px
    box-sizing border-box
    border-radius 4px
    background-color #F7FFF9
    font-size 16px
    line-height 26px
    text-align center
    img
      display inline-block
      width 88px
      height 88px
      margin 12px 0 20px
      vertical-align middle
    .van-button
      display block
      margin auto
      width 155px
      height 40px
      line-height 40px
      border none
      font-size 16px
      color #FFF
      border-radius 8px
      background-color #D00202
  .backIndex
    position absolute
    top 80px
    left 0
    border-radius 0 8px 8px 0
    box-shadow 0px 4px 7px 0px rgba(162,36,36,1)
    div
      width 50px
      height 50px
      padding 8px 11px 8px 9px
      box-sizing border-box
      border-radius 0 8px 8px 0
      color #D11A1A
      font-size 15px
      font-weight bold
      line-height 17px
      box-shadow 0px 4px 0px 0px #FD7903
      cursor pointer
      background linear-gradient(200deg,rgba(255,238,2,1) 0%,rgba(248,188,1,1) 100%)
</style>